import { __ } from '@wordpress/i18n';
import * as constants from './constants';
import * as generators from '../../generators';

const { generateResRangleControlAttributes } = generators;

const {
	CUSTOM_CONTAINER_WIDTH,
	GRID_COLUMNS,
	GRID_GAP,
	ROW_GAP,
	PAGINATION_SIZE,
	NAME_FONT_SIZE,
	DESIGNATION_FONT_SIZE,
	IMAGE_SIZE,
	IMAGE_BORDER_RADIUS,
	ICON_SIZE,
	ICON_ROUND_SIZE,
	ICON_BORDER_RADIUS,
	QR_POSITION_HORIZONTAL,
	QR_POSITION_VERTICAL,
	ICON_GAP,
	BORDER_WIDTH,
	IAMGE_SIZE,
	ABOUT_TITLE_FONT_SIZE,
	ABOUT_TITLE_ICON_FONT_SIZE,
	ABOUT_DESCRIPTION_FONT_SIZE,
	DATE_OF_BIRTH_FONT_SIZE,
	NATIONALITY_FONT_SIZE,
	CONTACT_FONT_SIZE,
	SKILL_TITLE_FONT_SIZE,
	SKILL_TITLE_ICON_FONT_SIZE,
	SKILL_NAME_FONT_SIZE,
	SKILL_PERCENTAGE_FONT_SIZE,
	SKILL_BAR_GAP,
	LANGUAGE_TITLE_FONT_SIZE,
	LANGUAGE_TITLE_ICON_FONT_SIZE,
	LANGUAGE_NAME_FONT_SIZE,
	LANGUAGE_PERCENTAGE_FONT_SIZE,
	LANGUAGE_BAR_GAP,
	HOBBY_TITLE_FONT_SIZE,
	HOBBY_TITLE_ICON_FONT_SIZE,
	HOBBY_NAME_FONT_SIZE,
	HOBBY_ICON_FONT_SIZE,
	HOBBY_ITEM_GAP,
	EDUCATION_TITLE_FONT_SIZE,
	EDUCATION_TITLE_ICON_FONT_SIZE,
	EDUCATION_PASSING_YEAR_FONT_SIZE,
	INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE,
	STUDY_FIELD_FONT_SIZE,
	EDUCATION_DEGREE_NAME_FONT_SIZE,
	EDUCATION_DESCRIPTION_FONT_SIZE,
	EXPERIENCE_TITLE_FONT_SIZE,
	EXPERIENCE_TITLE_ICON_FONT_SIZE,
	EXPERIENCE_COMPANY_FONT_SIZE,
	EXPERIENCE_DESIGNATION_FONT_SIZE,
	EXPERIENCE_DESCRIPTION_FONT_SIZE,
	EXPERIENCE_DATE_FONT_SIZE,
	REFERENCE_TITLE_FONT_SIZE,
	REFERENCE_TITLE_ICON_FONT_SIZE,
	REFERENCE_PHONE_FONT_SIZE,
	REFERENCE_NAME_FONT_SIZE,
	REFERENCE_JOB_POSITION_FONT_SIZE,
	REFERENCE_COMPANY_FONT_SIZE,
	REFERENCE_RELATION_FONT_SIZE,
	ABOUT_PADDING_TOP,
	ABOUT_PADDING_RIGHT,
	ABOUT_PADDING_BOTTOM,
	ABOUT_PADDING_LEFT,
	ABOUT_BORDER_RADIUS_TOP,
	ABOUT_BORDER_RADIUS_RIGHT,
	ABOUT_BORDER_RADIUS_BOTTOM,
	ABOUT_BORDER_RADIUS_LEFT,
	CONTACT_PADDING_TOP,
	CONTACT_PADDING_RIGHT,
	CONTACT_PADDING_BOTTOM,
	CONTACT_PADDING_LEFT,
	CONTACT_BORDER_RADIUS_TOP,
	CONTACT_BORDER_RADIUS_RIGHT,
	CONTACT_BORDER_RADIUS_BOTTOM,
	CONTACT_BORDER_RADIUS_LEFT,
	SKILL_PADDING_TOP,
	SKILL_PADDING_RIGHT,
	SKILL_PADDING_BOTTOM,
	SKILL_PADDING_LEFT,
	SKILL_BORDER_RADIUS_TOP,
	SKILL_BORDER_RADIUS_RIGHT,
	SKILL_BORDER_RADIUS_BOTTOM,
	SKILL_BORDER_RADIUS_LEFT,
	LANGUAGE_PADDING_TOP,
	LANGUAGE_PADDING_RIGHT,
	LANGUAGE_PADDING_BOTTOM,
	LANGUAGE_PADDING_LEFT,
	LANGUAGE_BORDER_RADIUS_TOP,
	LANGUAGE_BORDER_RADIUS_RIGHT,
	LANGUAGE_BORDER_RADIUS_BOTTOM,
	LANGUAGE_BORDER_RADIUS_LEFT,
	HOBBY_PADDING_TOP,
	HOBBY_PADDING_RIGHT,
	HOBBY_PADDING_BOTTOM,
	HOBBY_PADDING_LEFT,
	HOBBY_BORDER_RADIUS_TOP,
	HOBBY_BORDER_RADIUS_RIGHT,
	HOBBY_BORDER_RADIUS_BOTTOM,
	HOBBY_BORDER_RADIUS_LEFT,
	EDUCATION_PADDING_TOP,
	EDUCATION_PADDING_RIGHT,
	EDUCATION_PADDING_BOTTOM,
	EDUCATION_PADDING_LEFT,
	EDUCATION_BORDER_RADIUS_TOP,
	EDUCATION_BORDER_RADIUS_RIGHT,
	EDUCATION_BORDER_RADIUS_BOTTOM,
	EDUCATION_BORDER_RADIUS_LEFT,
	EXPERIENCE_PADDING_TOP,
	EXPERIENCE_PADDING_RIGHT,
	EXPERIENCE_PADDING_BOTTOM,
	EXPERIENCE_PADDING_LEFT,
	EXPERIENCE_BORDER_RADIUS_TOP,
	EXPERIENCE_BORDER_RADIUS_RIGHT,
	EXPERIENCE_BORDER_RADIUS_BOTTOM,
	EXPERIENCE_BORDER_RADIUS_LEFT,
	REFERENCE_PADDING_TOP,
	REFERENCE_PADDING_RIGHT,
	REFERENCE_PADDING_BOTTOM,
	REFERENCE_PADDING_LEFT,
	REFERENCE_BORDER_RADIUS_TOP,
	REFERENCE_BORDER_RADIUS_RIGHT,
	REFERENCE_BORDER_RADIUS_BOTTOM,
	REFERENCE_BORDER_RADIUS_LEFT,
	ABOUT_SECTION_PADDING_TOP,
	ABOUT_SECTION_PADDING_RIGHT,
	ABOUT_SECTION_PADDING_BOTTOM,
	ABOUT_SECTION_PADDING_LEFT,
	CONTACT_SECTION_PADDING_TOP,
	CONTACT_SECTION_PADDING_RIGHT,
	CONTACT_SECTION_PADDING_BOTTOM,
	CONTACT_SECTION_PADDING_LEFT,
	SKILL_SECTION_PADDING_TOP,
	SKILL_SECTION_PADDING_RIGHT,
	SKILL_SECTION_PADDING_BOTTOM,
	SKILL_SECTION_PADDING_LEFT,
	LANGUAGE_SECTION_PADDING_TOP,
	LANGUAGE_SECTION_PADDING_RIGHT,
	LANGUAGE_SECTION_PADDING_BOTTOM,
	LANGUAGE_SECTION_PADDING_LEFT,
	HOBBY_SECTION_PADDING_TOP,
	HOBBY_SECTION_PADDING_RIGHT,
	HOBBY_SECTION_PADDING_BOTTOM,
	HOBBY_SECTION_PADDING_LEFT,
	EDUCATION_SECTION_PADDING_TOP,
	EDUCATION_SECTION_PADDING_RIGHT,
	EDUCATION_SECTION_PADDING_BOTTOM,
	EDUCATION_SECTION_PADDING_LEFT,
	EXPERIENCE_SECTION_PADDING_TOP,
	EXPERIENCE_SECTION_PADDING_RIGHT,
	EXPERIENCE_SECTION_PADDING_BOTTOM,
	EXPERIENCE_SECTION_PADDING_LEFT,
	REFERENCE_SECTION_PADDING_TOP,
	REFERENCE_SECTION_PADDING_RIGHT,
	REFERENCE_SECTION_PADDING_BOTTOM,
	REFERENCE_SECTION_PADDING_LEFT,
	HEADER_PADDING_TOP,
	HEADER_PADDING_RIGHT,
	HEADER_PADDING_BOTTOM,
	HEADER_PADDING_LEFT,
	FOOTER_PADDING_TOP,
	FOOTER_PADDING_RIGHT,
	FOOTER_PADDING_BOTTOM,
	FOOTER_PADDING_LEFT,
	ITEM_BORDER_RADIUS_TOP,
	ITEM_BORDER_RADIUS_RIGHT,
	ITEM_BORDER_RADIUS_BOTTOM,
	ITEM_BORDER_RADIUS_LEFT,
	ITEM_PADDING_TOP,
	ITEM_PADDING_RIGHT,
	ITEM_PADDING_BOTTOM,
	ITEM_PADDING_LEFT,
	WRAPPER_BORDER_RADIUS,
	WRAPPER_PADDING_BOTTOM,
	WRAPPER_PADDING_TOP,
	WRAPPER_PADDING_LEFT,
	WRAPPER_PADDING_RIGHT,
	WRAPPER_MARGIN_TOP,
	WRAPPER_MARGIN_BOTTOM,
	WRAPPER_MARGIN_LEFT,
	WRAPPER_MARGIN_RIGHT,
	WRAPPER_BORDER_RADIUS_TOP,
	WRAPPER_BORDER_RADIUS_RIGHT,
	WRAPPER_BORDER_RADIUS_BOTTOM,
	WRAPPER_BORDER_RADIUS_LEFT,
} = constants;


// 👇 Common default data for most styles
const defaultUserData = {
	firstName: __( 'Edward', 'cv-builder' ),
	lastName: __( 'Shine', 'cv-builder' ),
	designation: __( 'Web Designer', 'cv-builder' ),
	email: 'info20@gmail.com',
	phoneNumber: '+00 952 165',
	address: __( '123 Main Street', 'cv-builder' ),
	city: __( 'New York', 'cv-builder' ),
	website: '',
	postalCode: '10001',
	profileImage: null,
};

// 👇 Create all similar styles dynamically (style1 to style25)
const generatedStyles = {};
for (let i = 1; i <= 28; i++) {
	generatedStyles[`style${i}`] = { ...defaultUserData };
}

// 👇 Add manually different ones like style26, style27
generatedStyles['style26'] = {
	firstName: __( 'Wade', 'cv-builder' ),
	lastName: __( 'Warren', 'cv-builder' ),
	designation: __( 'Account Manager', 'cv-builder' ),
	email: 'wade@example.com',
	phoneNumber: '+65 7657 4218',
	address: '',
	city: '',
	website: 'linkedin.com/wade',
	postalCode: '',
	profileImage: null,
};
generatedStyles['style27'] = {
	firstName: __( 'Brooklyn', 'cv-builder' ),
	lastName: __( 'Simmons', 'cv-builder' ),
	designation: __( 'Senior Manager, HR & Administration', 'cv-builder' ),
	address: __( 'London, United Kingdom', 'cv-builder' ),
	phoneNumber: '(44) 99 88 77 66',
	email: 'brokln.simm@email.com',
	city: '',
	website: '',
	postalCode: '',
};
generatedStyles['style28'] = {
	firstName: __('Esther', 'cv-builder'),
	lastName: __('Howard, ', 'cv-builder'),
	designation: __('Finance Manager', 'cv-builder'),
	address: __('2207 Beach Avenue, Austin, TX, ', 'cv-builder'),
	phoneNumber: __('(915) 44 33 22 11 20', 'cv-builder'),
	email: __('ester.ward@email.com, ', 'cv-builder'),
	city: '',
	website: 'Linkedin.com/in/esther, ',
	postalCode: '',
};

const attributes = {
	uniqueId: {
		type: 'string',
	},
	style: {
		type: 'string',
		default: 'style1',
	},
	themeColor: {
		type: 'string',
	},
	images: {
		type: 'array',
		default: []
	},
	headerBackgroundColor: {
		type: 'string',
	},
	leftColumnBgColor: {
		type: 'string',
	},
	rightColumnBgColor: {
		type: 'string',
	},
	bodyBgColor: {
		type: 'string',
	},
	footerBgColor: {
		type: 'string',
	},
	profileImage: {
		type: 'object',
		default: null
	},
	linkedinUrl: {
		type: 'string',
		link: '#',
	},
	firstName: {
		type: 'string',
		default: 'Edward',
	},
	lastName: {
		type: 'string',
		default: 'Shine',
	},
	userNameColor: {
		type: 'string'
	},
	aboutTitleColor: {
		type: 'string',
	},
	aboutTitleBgColor: {
		type: 'string',
	},
	aboutTitleIconColor: {
		type: 'string',
	},
	aboutDescriptionColor: {
		type: 'string',
	},
	aboutDateOfBirthColor: {
		type: 'string',
	},
	aboutNationalityColor: {
		type: 'string',
	},
	contactTitleColor: {
		type: 'string',
	},
	contactTitleBgColor: {
		type: 'string',
	},
	contactTitleIconColor: {
		type: 'string',
	},
	contactContentColor: {
		type: 'string',
	},
	addressColor: {
		type: 'string',
	},
	skillTitleColor: {
		type: 'string',
	},
	skillTitleBgColor: {
		type: 'string',
	},
	skillTitleIconColor: {
		type: 'string',
	},
	skillNameColor: {
		type: 'string',
	},
	skillPercentageColor: {
		type: 'string',
	},
	skillTopBgColor: {
		type: 'string',
	},
	skillBottomBgColor: {
		type: 'string',
	},
	languageTitleColor: {
		type: 'string',
	},
	languageTitleBgColor: {
		type: 'string',
	},
	languageTitleIconColor: {
		type: 'string',
	},
	languageNameColor: {
		type: 'string',
	},
	languagePercentageColor: {
		type: 'string',
	},
	languageTopBgColor: {
		type: 'string',
	},
	languageBottomBgColor: {
		type: 'string',
	},
	hobbiesTitleColor: {
		type: 'string',
	},
	hobbiesTitleBgColor: {
		type: 'string',
	},
	hobbiesTitleIconColor: {
		type: 'string',
	},
	hobbyNameColor: {
		type: 'string',
	},
	hobbyIconColor: {
		type: 'string',
	},
	educationTitleColor: {
		type: 'string',
	},
	educationTitleBgColor: {
		type: 'string',
	},
	educationTitleIconColor: {
		type: 'string',
	},
	educationDescriptionColor: {
		type: 'string',
	},
	educationYearColor: {
		type: 'string',
	},
	educationRoundShapeColor: {
		type: 'string',
	},
	educationLineColor: {
		type: 'string',
	},
	institutionColor: {
		type: 'string',
	},
	degreeNameColor: {
		type: 'string',
	},
	studyFieldColor: {
		type: 'string',
	},
	experienceTitleColor: {
		type: 'string',
	},
	experienceTitleBgColor: {
		type: 'string',
	},
	experienceTitleIconColor: {
		type: 'string',
	},
	experienceDescriptionColor: {
		type: 'string',
	},
	companyNameColor: {
		type: 'string',
	},
	experienceDesignationColor: {
		type: 'string',
	},
	experienceDateColor: {
		type: 'string',
	},
	experienceRoundShapeColor: {
		type: 'string',
	},
	experienceLineColor: {
		type: 'string',
	},
	referenceTitleColor: {
		type: 'string',
	},
	referenceTitleBgColor: {
		type: 'string',
	},
	referenceTitleIconColor: {
		type: 'string',
	},
	referenceNameColor: {
		type: 'string',
	},
	referenceContentColor: {
		type: 'string',
	},
	referenceJobPositionColor: {
		type: 'string',
	},
	referenceCompanyColor: {
		type: 'string',
	},
	referencePhoneColor: {
		type: 'string',
	},
	referenceRelationColor: {
		type: 'string',
	},
	awardNameColor: {
		type: 'string',
	},
	awardArrowColor: {
		type: 'string',
	},
	awardTitleColor: {
		type: 'string',
	},
	awardTitleBgColor: {
		type: 'string',
	},
	awardTitleIconColor: {
		type: 'string',
	},
	toolsNameColor: {
		type: 'string',
	},
	toolsArrowColor: {
		type: 'string',
	},
	toolsTitleColor: {
		type: 'string',
	},
	toolsTitleBgColor: {
		type: 'string',
	},
	toolsTitleIconColor: {
		type: 'string',
	},
	profileImage: {
		type: 'object',
		default: null
	},
	linkedinUrl: {
		type: 'string',
		link: '#',
	},
	contactTitle: {
		type: 'string',
		default: 'Contact',
	},
	isAboutVisible: {
		type: 'boolean',
		default: true,
	},
	showQRCode: {
		type: 'boolean',
		default: false,
	},
	isContactVisible: {
		type: 'boolean',
		default: true,
	},
	isSkillsVisible: {
		type: 'boolean',
		default: true,
	},
	isLanguageVisible: {
		type: 'boolean',
		default: true,
	},
	isHobbyVisible: {
		type: 'boolean',
		default: true,
	},
	isEducationVisible: {
		type: 'boolean',
		default: true,
	},
	isExperienceVisible: {
		type: 'boolean',
		default: true,
	},
	isReferenceVisible: {
		type: 'boolean',
		default: true,
	},
	isFooterVisible: {
		type: 'boolean',
		default: true,
	},
	dateOfBirth: {
		type: 'string',
		default: '01-01-2001',
	},
	aboutTitle: {
		type: 'string',
		default: __('About Me', 'cv-builder'),
	  },
	about: {
		type: 'string',
		default: __('Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.', 'cv-builder'),
	},
	skillTitle: {
		type: 'string',
		default: __('Skills', 'cv-builder'),
	},
	languageTitle: {
		type: 'string',
		default: __('Languages', 'cv-builder'),
	},
	hobbyTitle: {
		type: 'string',
		default: __('Hobby', 'cv-builder'),
	},
	educationTitle: {
		type: 'string',
		default: __('Education', 'cv-builder'),
	},
	experienceTitle: {
		type: 'string',
		default: __('Experience', 'cv-builder'),
	},
	referenceTitle: {
		type: 'string',
		default: __('Reference', 'cv-builder'),
	},
	isLinked: {
		type: 'boolean',
		default: true,
	},
	blockStyle: {
		type: 'object',
	},
	phoneNumber: {
		type: 'string',
		default: __('+00 952 165', 'cv-builder'),
	},
	email: {
		type: 'string',
		default: __('info20@gmail.com', 'cv-builder'),
	},
	address: {
		type: 'string',
		default: __('123 Main Street', 'cv-builder'),
	},
	city: {
		type: 'string',
		default: __('New York', 'cv-builder'),
	},
	postalCode: {
		type: 'string',
		default: __('10001', 'cv-builder'),
	},
	nationality: {
		type: 'string',
		default: __('USA', 'cv-builder'),
	},
	sectionCountOne: {
		type: 'string',
		default: 5
	},
	sectionCountTwo: {
		type: 'string',
		default: 4
	},
	sectionCountThree: {
		type: 'string',
		default: 4
	},
	sectionCountFour: {
		type: 'string',
		default: 4
	},
	sectionCountFive: {
		type: 'string',
		default: 4
	},
	sectionCountSix: {
		type: 'string',
		default: 4
	},
	sectionCountSeven: {
		type: 'string',
		default: 4
	},
	sectionCountEight: {
		type: 'string',
		default: 4
	},
	sectionCountNine: {
		type: 'string',
		default: 4
	},
	sectionCountTen: {
		type: 'string',
		default: 4
	},
	sectionCountEleven: {
		type: 'string',
		default: 4
	},
	sectionCountTwelve: {
		type: 'string',
		default: 4
	},
	sectionCountThirteen: {
		type: 'string',
		default: 3
	},
	sectionCountFourteen: {
		type: 'string',
		default: 5
	},
	sectionCountFifteen: {
		type: 'string',
		default: 5
	},
	sectionCountSixteen: {
		type: 'string',
		default: 4
	},
	sectionCountSeventeen: {
		type: 'string',
		default: 3
	},
	sectionCountEighteen: {
		type: 'string',
		default: 5
	},
	sectionCountNineteen: {
		type: 'string',
		default: 4
	},
	sectionCountTwenty: {
		type: 'string',
		default: 3
	},
	sectionCountTwentyOne: {
		type: 'string',
		default: 3
	},
	sectionCountTwentyTwo: {
		type: 'string',
		default: 4
	},
	sectionCountTwentyThree: {
		type: 'string',
		default: 3
	},
	sectionCountTwentyFour: {
		type: 'string',
		default: 3
	},
	sectionCountTwentyFive: {
		type: 'string',
		default: 3
	},

	customHasInitialized: {
		type: 'boolean',
		default: false
	},
	typography: {
		type: 'object',
		default: {
			fontFamily: 'Helvetica',
		},
	},
	userNameTypography: {
		type: 'object',
		default: {
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontStyle: '',
			textTransform: '',
			letterSpacing: '',
			wordSpacing: '',
			lineHeight: '',
		},
	},
	designationTypography: {
		type: 'object',
		default: {
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontStyle: '',
			textTransform: '',
			letterSpacing: '',
			wordSpacing: '',
			lineHeight: '',
		},
	},
	aboutTitleTypography: {
		type: 'object',
		default: {
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontStyle: '',
			textTransform: '',
			letterSpacing: '',
			wordSpacing: '',
			lineHeight: '',
		},
	},
	aboutDescriptionTypography: {
		type: 'object',
		default: {
			fontFamily: '',
			fontSize: '',
			fontWeight: '',
			fontStyle: '',
			textTransform: '',
			letterSpacing: '',
			wordSpacing: '',
			lineHeight: '',
		},
	},
	sectionItems: {
		type: 'array',
	},
	sectionItems1: {
		type: 'array'
	},
	sectionItems2: {
		type: 'array',
	},
	sectionItems3: {
		type: 'array',
	},
	// This attribute is responsible for style4 and style5 and style6
	sectionItems4: {
		type: 'array',
	},
	sectionItems5: {
		type: 'array',		
	},
	sectionItems6: {
		type: 'array',		
	},
	sectionItems7: {
		type: 'array',
	},
	sectionItems8: {
		type: 'array',		
	},
	sectionItems9: {
		type: 'array',		
	},
	sectionItems10: {
		type: 'array',		
	},
	sectionItems11: {
		type: 'array',
	},
	sectionItems12: {
		type: 'array',		
	},
	sectionItems13: {
		type: 'array',
	},
	sectionItems14: {
		type: 'array',		
	},
	sectionItems15: {
		type: 'array',		
	},
	sectionItems16: {
		type: 'array',
	},
	sectionItems17: {
		type: 'array',
	},
	sectionItems18: {
		type: 'array',		
	},
	sectionItems19: {
		type: 'array',		
	},
	sectionItems20: {
		type: 'array',		
	},
	sectionItems21: {
		type: 'array',
	},
	sectionItems22: {
		type: 'array',		
	},
	sectionItems23: {
		type: 'array',		
	},
	sectionItems24: {
		type: 'array',		
	},
	sectionItems25: {
		type: 'array',		
	},
	sixteenTemplateSections: {
		type: 'array',
		default: [
			{
				id: '1',
				type: 'about',
				title: 'About Me',
				description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum a incidunt, voluptatibus doloribus quod praesentium quibusdam provident?',
				dateOfBirth: '01-01-2001',
				nationality: 'USA',
			},
			{
				id: '2',
				type: 'skills',
				title: 'Skills',
				items: [
					{ name: 'JavaScript', percentage: 80 },
					{ name: 'HTML', percentage: 90 },
					{ name: 'CSS', percentage: 70 },
					{ name: 'React', percentage: 85 },
					{ name: 'WordPress', percentage: 75 },
					{ name: 'PHP', percentage: 95 },
					{ name: 'Python', percentage: 85 },
					{ name: 'AI', percentage: 79 },
					{ name: 'API', percentage: 74 },
				],
			},
			{
				id: '3',
				type: 'languages',
				title: 'Languages',
				items: [
					{ name: 'English', percentage: 90 },
					{ name: 'Spanish', percentage: 75 },
					{ name: 'Arabic', percentage: 75 },
				],
			},
			{
				id: '4',
				type: 'hobbies',
				title: 'Hobbies',
				items: [
					{ name: 'Music', icon: 'Music' },
					{ name: 'Movie', icon: 'Movie' },
					{ name: 'Writing', icon: 'Writing' },
					{ name: 'Football', icon: 'Football' },
				],
			},
			{
				id: '5',
				type: 'education',
				title: 'Education',
				items: [
					{
						institution: 'University of California',
						name: 'Computer Science',
						degree: 'Bachelor',
						city: 'California',
						fromDate: 2020,
						toDate: 2025,
						current: false,
						country: 'USA',
						educationDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.'
					},
					{
						institution: 'University of California',
						name: 'Computer Science',
						degree: 'Bachelor',
						city: 'California',
						fromDate: 2020,
						toDate: 2025,
						current: false,
						country: 'USA',
						educationDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.'
					},
					{
						institution: 'University of California',
						name: 'Computer Science',
						degree: 'Bachelor',
						city: 'California',
						fromDate: 2020,
						toDate: 2025,
						current: false,
						country: 'USA',
						educationDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.'
					},
				],
			},
			{
				id: '6',
				type: 'experience',
				title: 'Experience',
				items: [
					{
						name: 'University of California',
						designation: 'Web Developer',
						present: false,
						fromExpDate: '2020/10',
						toExpDate: '2025/05',
						experienceDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.',

					},
					{
						name: 'University of California',
						designation: 'Web Developer',
						present: false,
						fromExpDate: '2020/10',
						toExpDate: '2025/05',
						experienceDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.',
					},
					{
						name: 'University of California',
						designation: 'Web Developer',
						present: false,
						fromExpDate: '2020/10',
						toExpDate: '2025/05',
						experienceDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.',

					},
				],
			},
			{
				id: '7',
				type: 'reference',
				title: 'Reference',
				items: [
					{
						name: 'John Doe',
						jobPosition: 'CEO',
						company: 'Company Inc',
						phone: '1234567890',
						relation: 'Friend',

					},
					{
						name: 'John Doe',
						jobPosition: 'CEO',
						company: 'Company Inc',
						phone: '1234567890',
						relation: 'Friend',

					},
				],
			},
			{
				id: '8',
				type: 'awards',
				title: 'Achievements & Awards',
				items: [
					{ name: 'Top Finance Leader LATAM – Global Capital Solutions, 2022' },
					{ name: 'Outstanding Account Manager – Banco Nacional, 2018' },
					{ name: 'Reduced finance operating expenses by $250K annually' },
					{ name: 'Successfully led post-merger finance integration project across 3 countries' },
				],
			},
			{
				id: '9',
				type: 'tools',
				title: 'Tools & Technologies',
				items: [
					{ name: 'SAP, Oracle, QuickBooks, Xero' },
					{ name: 'Microsoft Excel (Advanced), Power BI' },
					{ name: 'Tableau, Zoho Finance Suite' },
					{ name: 'CRM Tools: Salesforce, HubSpot' },
					{ name: 'Banking platforms & compliance tools' },
				],
			},
		],
	},
	deletedSectionsData: {
		type: 'object',
		default: {},
	},
	socialIcon: {
		type: 'array',
		default: [
			{
				id: 1,
				icon: 'Facebook-f',
				link: '',
			},
			{
				id: 2,
				icon: 'Twitter',
				link: '',
			},
			{
				id: 3,
				icon: 'Instagram-line',
				link: '',
			},
			{
				id: 4,
				icon: 'Linkedin-in',
				link: '',
			}
		],
	},

	footerLink: {
		type: 'string',
		default: '#',
	},
	aboutPanel: {
		type: 'boolean',
		default: false,
	},
	skillPanel: {
		type: 'boolean',
		default: false,
	},
	languagePanel: {
		type: 'boolean',
		default: false,
	},
	hobbyPanel: {
		type: 'boolean',
		default: false,
	},
	educationPanel: {
		type: 'boolean',
		default: false,
	},
	experiencePanel: {
		type: 'boolean',
		default: false,
	},
	referencePanel: {
		type: 'boolean',
		default: false,
	},
	footerPanel: {
		type: 'boolean',
		default: false,
	},
	contactPanel: {
		type: 'boolean',
		default: false,
	},
	signature: {
		type: 'object',
		default: null
	},
	footerBtnText: {
		type: 'string',
		default: __('Contact Me', 'cv-builder'),
	},
	footerBtnLink: {
		type: 'string',
		default: '#',
	},
	containerWidth: {
		type: 'string',
		default: 'container',
	},
	titleTag: {
		type: 'string',
		default: 'h2',
	},
	nameColor: {
		type: 'string',
	},
	nameAlign: {
		type: 'string',
	},
	designationAlign: {
		type: 'string',
	},
	iconAlign: {
		type: 'string',
	},
	nameHoverColor: {
		type: 'string',
	},
	designationColor: {
		type: 'string',
	},
	iconColor: {
		type: 'string',
	},
	iconBgNormalColor: {
		type: 'string',
	},
	iconHoverColor: {
		type: 'string',
	},
	iconBgHoverColor: {
		type: 'string',
	},
	textAlign: {
		type: 'string',
		default: 'left',
	},
	contentBgColor: {
		type: 'string',
	},
	contentBgHoverColor: {
		type: 'string',
	},
	itemBgColor: {
		type: 'string',
	},
	itemBgHoverColor: {
		type: 'string',
	},
	itemBgOverlayColor: {
		type: 'string',
	},
	wrapperBgColor: {
		type: 'string',
	},
	wrapperGradientBg: {
		type: 'string',
	},
	hideOnDesktop: {
		type: 'boolean',
		default: false,
	},
	hideOnTablet: {
		type: 'boolean',
		default: false,
	},
	hideOnMobile: {
		type: 'boolean',
		default: false,
	},
	mainWrapperBgColor: {
		type: 'string',
	},
	bgPosition: {
		type: 'string',
		default: '',
	},
	bgAttachment: {
		type: 'string',
		default: '',
	},
	bgRepeat: {
		type: 'string',
		default: '',
	},
	bgSize: {
		type: 'string',
		default: '',
	},
	imageUrl: {
		type: 'object',
	},
	zIndex: {
		type: 'string',
	},
	wrapperId: {
		type: 'string',
	},
	customCSS: {
		type: 'string',
		default: '',
	},
	hasInitialized: {
		type: 'object',
		default: {
			style1: false,
			style2: false,
		},
	},
	sectionItems26: {
		type: 'array',		
	},
	sectionItems27: {
		type: 'array',
	},
	sectionItems28: {
		type: 'array',
	},
	dataByStyle: {
		type: 'object',
		default: generatedStyles,
	},
	isPopoverVisible: {
		type: 'boolean',
		default: false,
	},
	isBoxShadowActive: {
		type: 'boolean',
		default: false,
	},
	...generateResRangleControlAttributes({
		controlName: CUSTOM_CONTAINER_WIDTH,
		defaults: {
			[`${CUSTOM_CONTAINER_WIDTH}DeskRange`]: 1200,
			[`${CUSTOM_CONTAINER_WIDTH}TabRange`]: 700,
			[`${CUSTOM_CONTAINER_WIDTH}MobRange`]: 300,
		},
	}),
	...generateResRangleControlAttributes({
		controlName: GRID_GAP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ROW_GAP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_BORDER_RADIUS,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_GAP,
		defaults: {
			[`${ICON_GAP}DeskRange`]: 10,
			[`${ICON_GAP}TabRange`]: 10,
			[`${ICON_GAP}MobRange`]: 10,
		},
	}),
	...generateResRangleControlAttributes({
		controlName: IAMGE_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: BORDER_WIDTH,
		defaults: {
			[`${BORDER_WIDTH}DeskRange`]: 1,
			[`${BORDER_WIDTH}TabRange`]: 1,
			[`${BORDER_WIDTH}MobRange`]: 1,
		},
	}),
	...generateResRangleControlAttributes({
		controlName: NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: DESIGNATION_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: IMAGE_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: IMAGE_BORDER_RADIUS,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_ROUND_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_GAP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_BORDER_RADIUS,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: QR_POSITION_HORIZONTAL,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: QR_POSITION_VERTICAL,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: DATE_OF_BIRTH_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: NATIONALITY_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_DESCRIPTION_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: PAGINATION_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_BORDER_RADIUS,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ICON_GAP,
		defaults: {
			[`${ICON_GAP}DeskRange`]: 8,
			[`${ICON_GAP}TabRange`]: 8,
			[`${ICON_GAP}MobRange`]: 8,
		},
	}),
	...generateResRangleControlAttributes({
		controlName: IAMGE_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_PERCENTAGE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_PERCENTAGE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_ITEM_GAP,
		defaults: {},
	}),

	// Education Section
	...generateResRangleControlAttributes({
		controlName: EDUCATION_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_PASSING_YEAR_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: STUDY_FIELD_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_DEGREE_NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_DESCRIPTION_FONT_SIZE,
		defaults: {},
	}),

	// Experience Section
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_COMPANY_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_DESIGNATION_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_DESCRIPTION_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_DATE_FONT_SIZE,
		defaults: {},
	}),
	// Reference Section
	...generateResRangleControlAttributes({
		controlName: REFERENCE_TITLE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_TITLE_ICON_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_NAME_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_JOB_POSITION_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_COMPANY_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_PHONE_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_RELATION_FONT_SIZE,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ABOUT_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: CONTACT_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: SKILL_BAR_GAP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: LANGUAGE_BAR_GAP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HOBBY_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EDUCATION_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: EXPERIENCE_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_SECTION_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_SECTION_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_SECTION_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: REFERENCE_SECTION_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HEADER_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HEADER_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HEADER_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: HEADER_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: FOOTER_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: FOOTER_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: FOOTER_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: FOOTER_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: BORDER_WIDTH,
		defaults: {
			[`${BORDER_WIDTH}DeskRange`]: 1,
			[`${BORDER_WIDTH}TabRange`]: 1,
			[`${BORDER_WIDTH}MobRange`]: 1,
		},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: ITEM_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_PADDING_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_PADDING_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_PADDING_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_PADDING_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_BORDER_RADIUS,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_MARGIN_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_MARGIN_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_MARGIN_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_MARGIN_LEFT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_BORDER_RADIUS_TOP,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_BORDER_RADIUS_RIGHT,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_BORDER_RADIUS_BOTTOM,
		defaults: {},
	}),
	...generateResRangleControlAttributes({
		controlName: WRAPPER_BORDER_RADIUS_LEFT,
		defaults: {},
	}),
};

export default attributes;